import { useEffect } from "react";
import { Flex } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { useInvestorWizard } from "../context";
import { ProfileToInvestorView } from "../ProfileStep/ProfileToInvestorView";
import { useProfileComparison } from "../ProfileStep/ProfileToInvestorView/useProfileComparison";
import { useCaseInvestmentAccount } from "../useCaseInvestmentAccount";
import { CaseInfoSummaryCard } from "./CaseInfoSummaryCard";
import { ReviewFooter } from "./ReviewFooter";
import * as styles from "./styles_vanilla.css";
import { SummaryCard } from "./SummaryCard";

export const ReviewStep = () => {
  const {
    caseInfo,
    newProfileData,
    selectedProfileId,
    selectedProfileName,
    selectedProfileIsIaAssociated,
    goBack,
    goToStep,
    setFooterContent,
  } = useInvestorWizard();

  const { arenaId, entityId, investmentAccountId, resolveSettled } =
    useCaseInvestmentAccount(caseInfo);
  const { matchData, queryResult } = useProfileComparison({
    arenaId,
    entityId,
    investmentAccountId,
    investmentAccountSettled: resolveSettled,
    profileId: newProfileData ? null : Number(selectedProfileId),
    profileName: selectedProfileName,
    isIaAssociated: selectedProfileIsIaAssociated,
    newProfile: newProfileData,
    clientName: caseInfo?.clientName ?? null,
  });

  const hasNewProfile = Boolean(caseInfo && newProfileData);
  const hasExistingProfile = Boolean(caseInfo && selectedProfileId && !newProfileData);
  const hasData = hasNewProfile || hasExistingProfile;

  useEffect(() => {
    if (!hasData) {
      setFooterContent(null);
      return undefined;
    }
    setFooterContent(<ReviewFooter />);
    return () => setFooterContent(null);
  }, [hasData, setFooterContent]);

  if (!caseInfo || !hasData) return null;

  return (
    <Flex flexDirection="column" gap={Sizes.LG} className={styles.reviewContainer}>
      <CaseInfoSummaryCard
        caseInfo={caseInfo}
        category={newProfileData?.category}
        onBack={goBack}
        onEdit={() => goToStep("case-information")}
      />
      <SummaryCard
        title="Compliance profile"
        subtitle="Review the profile to assign to this onboarding case."
        onEdit={goBack}
      >
        <ProfileToInvestorView
          matchData={matchData}
          queryResult={queryResult}
          highlightProfileColumn={false}
          onEditProfile={goBack}
        />
      </SummaryCard>
    </Flex>
  );
};
